export default __webpack_public_path__ + "static/websdk-sample2-34f2101a05c4b21c23ec6dc2e54619f6.png";